import React, { useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";

import { ButtonPrimaryLink, ButtonSecondaryLink } from "@components/Button";
import Layout from "@components/Layout";

import { Row } from "@styles/grid";

import BrandsTable from "./BrandsTable";
import { getAllBrands } from "@actions/brands.action";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem auto 5.5rem;
  max-width: 125rem;
  width: 100%;
  padding: 0 2.5rem;
`;

const Brands = () => {
  const dispatch = useDispatch();
  const { brands } = useSelector(({ brands }) => brands);

  useEffect(() => {
    (async () => {
      const brandsNotEmpty = brands && brands.length;

      if (!brandsNotEmpty) {
        await dispatch(getAllBrands());
      }
    })();
  }, []);

  return (
    <Layout pageTitle="Brands">
      <Content>
        <Row justify="space-between" margin="2rem 0">
          <ButtonSecondaryLink outlined uppercase href="/">
            Back to Dashboard
          </ButtonSecondaryLink>
          <ButtonPrimaryLink uppercase href="/brands/add">
            Add brand
          </ButtonPrimaryLink>
        </Row>
        <BrandsTable />
      </Content>
    </Layout>
  );
};

export default Brands;
